module.exports = __webpack_public_path__ + "img/premium.b076860a.svg";